import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '6',
  label: 'Років досвіду у праві'
}, {
  value: '1000+',
  label: 'Успішних справ'
}, {
  value: '100%',
  label: 'Конфіденційність'
}];
export function Stats() {
  return <section className="py-12 bg-white border-y border-slate-100" data-id="element-107">
      <div className="max-w-7xl mx-auto px-6" data-id="element-108">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-slate-100" data-id="element-109">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center pt-8 md:pt-0 first:pt-0" data-id="element-110">
              <h3 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-2 tracking-tight" data-id="element-111">
                {stat.value}
              </h3>
              <p className="text-sm font-medium text-slate-500 uppercase tracking-wider" data-id="element-112">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}